export const ANNOTATION_STYLES = [
  'background-color: oklch(93% 0.03 300); color: oklch(34% 0.18 300)',
  'background-color: oklch(93% 0.03 250); color: oklch(34% 0.18 250)',
  'background-color: oklch(93% 0.03 200); color: oklch(34% 0.18 200)',
  'background-color: oklch(93% 0.03 150); color: oklch(34% 0.18 150)',
  'background-color: oklch(93% 0.03 100); color: oklch(34% 0.18 100)',
  'background-color: oklch(93% 0.03 50); color: oklch(34% 0.18 50)',
  'background-color: oklch(93% 0.03 0); color: oklch(34% 0.18 0)',
] as const;
